import type { ComponentType } from 'react';
import type { ConnectorOperation, MyGrantsConnector } from './schemas';

export interface ConnectorDirectProps {
  connector: MyGrantsConnector;
  operations: ConnectorOperation[];
  onInvoke: (operationName: string, input: Record<string, unknown>) => Promise<string>;
}

// Registry: connectorId → custom component.
// Empty in v1 — all connectors use the generic schema-driven UI.
// To add a custom UI: CUSTOM_CONNECTOR_UIS['dropbox'] = lazy(() => import('./connectors/dropbox/DirectUI'));
export const CUSTOM_CONNECTOR_UIS: Record<string, ComponentType<ConnectorDirectProps>> = {};
